import { useT } from '@/lib/useLang';

/**
 * Du post à l'opportunité : une photo à gauche, quatre étapes à droite, sur le
 * modèle d'une section que Stephen a montrée le 01/10/2026. Les étapes décrivent
 * ce qu'un post qui démarre au-dessus de zéro rend possible, sans rien promettre
 * que le service ne fait pas (ni viralité, ni leads, ni rapport).
 *
 * Photo : visuel aux couleurs de NeverZero fourni par Stephen le 01/10/2026,
 * recadré en 1000×1200 (5:6).
 */
export function Journey() {
  const t = useT();

  return (
    <section className="nz-journey">
      <picture className="nz-journey__photo">
        <source srcSet="/photos/working-together.webp" type="image/webp" />
        <img
          src="/photos/working-together.jpg"
          alt={t.journeyImageAlt}
          width={1000}
          height={1200}
          loading="lazy"
          decoding="async"
        />
      </picture>
      <div>
        <h2 className="nz-h2">{t.journeyH2}</h2>
        <p className="nz-lead">{t.journeyP}</p>
        <ul className="nz-journey__steps">
          {t.journeySteps.map((step) => (
            <li className="nz-journey__step" key={step.title}>
              <div className="nz-journey__title">{step.title}</div>
              <p className="nz-journey__body">{step.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
